import { Badge } from "@/components/ui/badge";

import type { PipelineRow } from "../../api";

const REL_LABEL_OUT: Record<string, string> = {
  merged_into: "Merged into",
  split_from: "Split from",
  subcustomer_of: "Sub of",
  continuation_of: "Continues",
};

const REL_LABEL_IN: Record<string, string> = {
  merged_into: "Absorbed",
  split_from: "Split off",
  subcustomer_of: "Hosts",
  continuation_of: "Continued by",
};

/** Tiny chips rendered alongside the account name. Outgoing first, then
 *  incoming. Light tint per the design-system chip emphasis rule — these are
 *  context cues, not attention-grabbers. */
export function LinkBadges({ links }: { links: PipelineRow["account_links"] }) {
  if (!links) return null;
  const out = links.outgoing || [];
  const inc = links.incoming || [];
  if (!out.length && !inc.length) return null;
  return (
    <>
      {out.map((l) => (
        <Badge
          key={`o-${l.id}`}
          variant="info"
          title={l.note ?? `${l.relationship} → QB-${l.other_qb_id}`}
          className="font-normal"
        >
          {REL_LABEL_OUT[l.relationship] ?? l.relationship}
          {l.other_name ? ` ${l.other_name}` : ` QB-${l.other_qb_id}`}
        </Badge>
      ))}
      {inc.map((l) => (
        <Badge
          key={`i-${l.id}`}
          variant="info"
          title={l.note ?? `${l.other_name ?? "QB-" + l.other_qb_id} → ${l.relationship} this`}
          className="font-normal"
        >
          {REL_LABEL_IN[l.relationship] ?? l.relationship}
          {l.other_name ? ` ${l.other_name}` : ` QB-${l.other_qb_id}`}
        </Badge>
      ))}
    </>
  );
}

export function ResellerBadge() {
  return (
    <Badge
      variant="info"
      className="font-normal"
      title="This account has a master Reseller/License agreement."
    >
      Reseller
    </Badge>
  );
}
